import { Component, ChangeDetectionStrategy, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { CalendarService } from 'app/_servicios/calendar.service';

@Component({
  selector: 'app-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgendaComponent implements OnInit {
  private calendarService = inject(CalendarService);
  private cdr = inject(ChangeDetectorRef);

  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();

  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = false;

  async ngOnInit() {
    await this.refreshEvents();
  }

  async refreshEvents() {
    try {
      // Usamos el ID especial 'default-tech-agenda' que el backend reconoce para la agenda de equipos
      const backendEvents = await this.calendarService.getEvents('default-tech-agenda');

      this.events = backendEvents.map(event => ({
        id: event.id,
        start: new Date(event.start_date),
        end: event.end_date ? new Date(event.end_date) : undefined,
        title: event.title,
        color: this.getEventColor(event.type),
        allDay: event.all_day,
        meta: {
          linkedId: event.linkedId,
          linkedType: event.linkedType,
          description: event.description,
          type: event.type
        }
      }));

      this.cdr.markForCheck();
    } catch (error) {
      console.error('Error loading agenda events:', error);
    }
  }

  private getEventColor(type: string): any {
    switch (type) {
      case 'CALIBRATION':
        return { primary: '#8B5CF6', secondary: '#EDE9FE' }; // Violet
      case 'PREVENTIVE':
        return { primary: '#3B82F6', secondary: '#DBEAFE' }; // Blue
      case 'CORRECTIVE':
        return { primary: '#EF4444', secondary: '#FEE2E2' }; // Red
      case 'VERIFICATION':
        return { primary: '#10B981', secondary: '#D1FAE5' }; // Emerald
      default:
        return { primary: '#64748B', secondary: '#F1F5F9' }; // Slate
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventClicked({ event }: { event: CalendarEvent }): void {
    console.log('Event clicked', event);
    alert(`📅 Evento: ${event.title}\nID: ${event.id}\n${event.meta?.description ? '📝 ' + event.meta.description : ''}`);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
    this.refreshEvents();
  }
}
